export default "__VITE_ASSET__BxLe_yiK__"